<div class="contenido">
    <div class="row secc1">
        <div class="col left">
            <h2>
                Preguntas Frecuentes
            </h2>
            <h3>
                Familiarizate con Triidy
            </h3>
            <p>
                Si no estás familiarizado con Triidy o quieres saber de que se trata la plataforma, esta guía te ayudará a encontrar más información sobre Triidy todas sus funcionalidades.
            </p>
            <p><span>¿Tienes alguna pregunta?</span></p>
        </div>
        <div class="col right">
            <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Ayuda-new.png" alt="">
            <img class="globo1" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Globo1-new.png" alt="">
            <img class="globo3" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Globo3-new.png" alt="">
            <img class="globo4" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Globo4-new.png" alt="">

        </div>
    </div>
    <div class="row secc2">
        <div class="accordion" id="accordionTriidy">
            <div class="accordion-item" *ngFor="let preg of Preguntas">
                <h2 class="accordion-header" [id]="preg.idCabeza">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#'+ preg.target" aria-expanded="false" [attr.aria-controls]="preg.target">
                        {{ preg.Cabeza }}
                    </button>
                </h2>
                <div [id]="preg.target" class="accordion-collapse collapse" [attr.aria-labelledby]="preg.idCabeza" data-bs-parent="#accordionTriidy">
                    <div class="accordion-body">
                        <h4>{{ preg.titulo }}</h4>
                        <p [innerHTML]="preg.texto"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="row secc3">
        <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/UsaWP-new.png" alt="">
    </div> -->
    <div class="row secc4">
        <p>Ayudando a los comerciantes a hacer el negocio de sus sueños</p>
        <div class="metrica">
            <h2>5.000</h2>
            <p>Usuarios</p>
        </div>
        <div class="metrica">
            <h2>+2.000</h2>
            <p>Productos disponibles</p>
        </div>
        <div class="metrica">
            <h2>+750.000</h2>
            <p>Transacciones realizadas</p>
        </div>
        <div class="metrica">
            <h2>+1.100</h2>
            <p>Ciudades y municipios</p>
        </div>
    </div>
    <div class="row secc5" *ngIf="newsVista">
        <p>Regístrate para recibir las últimas noticias y novedades acerca de Triidy.</p>
        <form action="" [formGroup]="newsForm" (ngSubmit)="registroNws()">
            <p class="intros">
                <input class="inputs" type="text" name="nombre" id="nombre" formControlName="nombre" required />
                <label for="nombre" alt="Nombre" placeholder="Nombre"></label>
            </p>
            <p class="intros">
                <input class="inputs" type="email" name="email" id="email" formControlName="email" required />
                <label for="email" alt="Correo" placeholder="Correo"></label>
            </p>
            <button type="submit" class="btn" [disabled]="!newsForm.valid">Suscríbete</button>
        </form>
    </div>
    <div class="row secc6">
        <h2>Gestiona y organiza tu tienda virtual desde tu computador o desde tu celular.</h2>
        <!-- <button class="btn" routerLink="/Regístrate">Regístrate Ahora</button> -->
        <button class="btn" (click)="clickM()">Regístrate Ahora</button>
    </div>
    <div class="row secc7">
        <p>Con el apoyo y acompañamiento de:</p>
        <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Acompa12-new.png" alt="">
    </div>
</div>